import Controller from "./pieChart.controller";
import template from "./pieChart.html";

const pieChart = {
  template,
  controller: Controller,
  bindings: {
    data: "<",
    title: "@",
    avg: "<",
    count: "<",
    field: "@",
    tooltipContent: "@",
    height: "@",
  },
};

export default pieChart;



// WEBPACK FOOTER //
// ./src/components/pieChart/pieChart.component.js